// Import types
import { LineTag } from '../tables';

export const NET_SPT_TAG: LineTag = {
    icon: 'fas fa-stop-circle',
    color: '#F72119',
    text: 'Stelpost na staart'
};

export const GROSS_SPT_TAG: LineTag = {
    icon: 'fas fa-stop-circle',
    color: '#1951f7',
    text: 'Stelpost voor staart'
};

export const LINE_TAGS: { [id: string]: LineTag } = {
    'net_spt': NET_SPT_TAG,
    'gross_spt': GROSS_SPT_TAG
}